import React, { SVGProps } from 'react'

const NewLightIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13.6154 10.4211V2L5 13.5789H10.3846V22L19 10.4211H13.6154Z' fill='url(#paint0_linear_1850_24011)' />
      <defs>
        <linearGradient id='paint0_linear_1850_24011' x1='12' y1='2' x2='12' y2='22' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#A0E8FF' />
          <stop offset='1' stopColor='#33CEFF' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default NewLightIcon
